const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
var VueCookie = require('vue-cookie');
const deleteAllCookies = function(){
    console.log(VueCookie)
    for (const [key, value] of Object.entries(cliStorNames)){
        console.log(value)
        VueCookie.delete(value.name)
    }
}

const deleteAllLocalStorageItems = function(){
    for (const [key, value] of Object.entries(cliStorNames)){
        for (const [key, value] of Object.entries(cliStorNames)){
            localStorage.removeItem(value.name)
        }
    }
}

module.exports = {deleteAllCookies, deleteAllLocalStorageItems}


// WEBPACK FOOTER //
// ./src/common/clientStorageOperations.js